import type { Process } from "types/types";
import { PnlCategoriesEnum } from "types/enums";
import {
  useExpandedTilesDataForProcess,
  useLatestSegmentForProcess,
} from "../expandedTileUtils";
import { SingleLineModule } from "./ExpandedTileModules";
import styled from "styled-components/macro";
import { useSettings } from "contexts/SettingsManager/SettingsManager";

const MAX_OPERATOR_NAME_CHARS_BEFORE_OVERFLOW = 13;

/** Expanded Tile module showing operator name */
export function TileOperatorNameModule({ process }: { process: Process }) {
  const expandedTilesData = useExpandedTilesDataForProcess(process.id);
  const operator = expandedTilesData?.operator;
  const latestSegment = useLatestSegmentForProcess(process.id);
  const pnlCategory = latestSegment?.pnl.category;
  const isUncollected = pnlCategory === PnlCategoriesEnum.uncollected;
  const isLoading = !expandedTilesData && !isUncollected;
  const { tileScaleMultiplier } = useSettings();

  // for short names, we can show the whole name; otherwise only show the first word
  const isShortOperatorName =
    operator?.name &&
    operator.name.length <= MAX_OPERATOR_NAME_CHARS_BEFORE_OVERFLOW;
  const operatorName = isShortOperatorName
    ? operator?.name
    : operator?.name?.split(" ")[0];
  return (
    <SingleLineModule
      loading={isLoading}
      data={
        <TileOperatorNameStyles
          className={operatorName ? "operator-name" : ""}
          $tileScaleMultiplier={tileScaleMultiplier ** 0.45}
        >
          {operatorName || "-no operator-"}
        </TileOperatorNameStyles>
      }
    />
  );
}

const TileOperatorNameStyles = styled.div<{ $tileScaleMultiplier: number }>`
  &.operator-name {
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  /* "-no operator-" appears slightly smaller */
  &:not(.operator-name) {
    transform: scale(${props => 0.9 * props.$tileScaleMultiplier});
    font-weight: normal;
  }
`;
